import { IMutations, IMutationsRegisterApplicantMutationPayload } from './mutations.types'
import { IRegistrationInfoData } from '@/entities'
import { IState } from '../store.types'


export const mutations: IMutations = {

  /** register applicant */
  registerApplicant (state: IRegistrationInfoData , payload: IMutationsRegisterApplicantMutationPayload): void {
      state = payload.registrationInfo
  }
}